<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WZ6CPw/images/9780865716711.jpg?1692197075038" alt="This image is the cover for the book Making Home, Mother Earth News Books for Wiser Living"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Making Home, Mother Earth News Books for Wiser Living
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Shows us why the actions that prepare us for emergencies and energy descent are the right things to do no matter what the future brings.” —Toby Hemenway, author of <i>Gaia’s Garden</i></b><br/>  <br/> Other books tell us how to live the good life—but you might have to win the lottery to do it. <i>Making Home</i> is about improving life with the real people around us and the resources we already have. While encouraging us to be more resilient in the face of hard times, author Sharon Astyk also points out the beauty, grace, and elegance that result, because getting the most out of everything we use is a way of transforming our lives into something much more fulfilling.<br/>  <br/> Written from the perspective of a family who has already made this transition, <i>Making Home</i> shows readers how to turn the challenge of living with less into settling for more—more happiness, more security, and more peace of mind. Learn simple but effective strategies to:<br/>  <br/> ·       Save money on everything from heating and cooling to refrigeration, laundry, water, sanitation, cooking, and cleaning<br/> ·       Create a stronger, more resilient family<br/> ·       Preserve more for future generations<br/>  <br/> We must make fundamental changes to our way of life in the face of ongoing economic crisis and energy depletion. <i>Making Home</i> takes the fear out of this prospect, and invites us to embrace a simpler, more abundant reality.<br/>  <br/> “Americans are born to be transient—Sharon Astyk has the prescription for dealing with that genetic disease, and building a healthy nativeness into our lives.” —Bill McKibben, <i>New York Times</i>–bestselling author<br/>  <br/> “Exhaustively researched and compassionately delivered.” —Harriet Fasenfest, author of <i>A Householder’s Guide to the Universe</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Astyk
      </h2>
      
      <p class="authorDescription body article">Sharon Astyk is a writer, teacher, blogger, and farmer who raises vegetables, poultry and dairy goats with her family in upstate New York. She and her family use 80% less energy and resources than the average American household. Sharon is a member of the Board of Directors of ASPO-USA and the award-winning author of three previous books including Depletion and Abundance and Independence Days.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New Society Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44e50700